import { render, staticRenderFns } from "./InodeAclInput.vue?vue&type=template&id=5b9d02fc&scoped=true&lang=pug"
import script from "./InodeAclInput.vue?vue&type=script&lang=js"
export * from "./InodeAclInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9d02fc",
  null
  
)

export default component.exports